import { AbstractControl } from '@angular/forms';
import { traverseControl } from '../traverse-control';

export function touchAndUpdateControl(root: AbstractControl) {
  traverseControl(root, (control) => control.markAsTouched());
  root.updateValueAndValidity({ onlySelf: false });
}
